import type { ProjectId } from 'common/types'

import type {
  AggregationType,
  Calculation,
  FormDataML,
  HorizonCalculation,
  HorizonsExtensionParams,
} from '../../types'
import type {
  HorizonDetectionInfo as ApiHorizonDetectionInfo,
  MlServiceType as ApiMlServiceType,
  ParamsAggregation as ApiParamsAggregation,
} from './__generated__/data-contracts'

export function convertToMlCalcHorizonModel(
  calculation: Calculation,
  formData: FormDataML,
  projectId: ProjectId,
): { data: ApiHorizonDetectionInfo; query: { mlServiceType: ApiMlServiceType } } {
  const algorithm = formData.algorithm as HorizonsExtensionParams

  const surveyId = calculation.params?.seismicSurvey.entity?.entityId
  if (!surveyId) {
    throw Error('Не задан id сейсмической съемки')
  }

  const interpretationId = (calculation.params as HorizonCalculation).horizon.entity?.entityId
  if (!interpretationId) {
    throw Error('Не задан id интерпретации')
  }

  return {
    data: {
      surveyId,
      interpretationId,
      projectId,
      name: calculation.name,
      detectionType: 'HorizonDetection',
      horizonDetectionInputsParams: {
        height: +algorithm.cropSize,
        nIters: algorithm.iterations,
        overlapFactor: algorithm.overlap,
        aggregation: getAggregation(algorithm.aggregation),
      },
    },
    query: {
      mlServiceType: algorithm.mlServiceToUse ?? 'IAAS',
    },
  }
}

function getAggregation(type: AggregationType): ApiParamsAggregation {
  switch (type) {
    case 'mean':
      return 'Mean'
    case 'max':
      return 'Max'
    case 'weighted':
      return 'Weighted'
  }
}
